import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type FeedbackPageState, type FeedbackPage } from "../../types/state";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { type FeedbackPageFormFields } from "../../Details/types";

const initialState: FeedbackPageState = {
  feedbackPage: {
    videoUrl: "",
    uploadedVideos: [],
    message: "",
  },
  isLoading: false,
  isLoaded: false,
  isUploadingVideo: false,
};

const feedbackPageSlice = createSlice({
  name: `${ReducerNamespaceTypes.Library}/${ReducerEntityPrefixTypes.ThreatDefenceCampaigns}/feedbackPage`,
  initialState,
  reducers: {
    saveFeedbackPage(state: FeedbackPageState, action: PayloadAction<FeedbackPageFormFields>) {
      const video = action.payload.uploadedVideos[0];
      const uploadedVideos = video ? [video] : [];

      state.feedbackPage.videoUrl = action.payload.videoUrl;
      state.feedbackPage.uploadedVideos = uploadedVideos;
      state.feedbackPage.message = action.payload.message;
    },
    setVideoIsUploading(state: FeedbackPageState) {
      state.isUploadingVideo = true;
    },
    setVideoUrl(state: FeedbackPageState, action: PayloadAction<string>) {
      state.feedbackPage.videoUrl = action.payload;
      state.isUploadingVideo = false;
    },
    clearFeedbackPage: () => initialState,
    reqFeedbackPage(state: FeedbackPageState) {
      state.isLoading = true;
    },
    gotFeedbackPage(state: FeedbackPageState, action: PayloadAction<FeedbackPage>) {
      const { videoName: name, videoSize: size } = action.payload;
      state.isLoaded = true;
      state.isLoading = false;
      state.feedbackPage.videoUrl = action.payload.videoUrl;
      state.feedbackPage.uploadedVideos =
        Object.keys(action.payload).length === 0 ? [] : [{ name, size, type: "", lastModified: 0 }];
      state.feedbackPage.message = action.payload.message ?? "";
    },
    errFeedbackPage(state: FeedbackPageState, action: PayloadAction<Error>) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  saveFeedbackPage,
  setVideoIsUploading,
  setVideoUrl,
  clearFeedbackPage,
  reqFeedbackPage,
  gotFeedbackPage,
  errFeedbackPage,
} = feedbackPageSlice.actions;

export default feedbackPageSlice.reducer;
